import React from 'react';
import styled from 'styled-components';
import times from 'lodash/times';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';

const Grid = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 16,
  px: 8,
  py: 16,
});

interface SelectHouseholdMemberModalLoadingProps {
  onRequestClose(): void;
}

export const SelectHouseholdMemberModalLoading = ({
  onRequestClose,
}: SelectHouseholdMemberModalLoadingProps) => (
  <Modal
    contentLabel="Select Household Member"
    isOpen
    shouldCloseOnOverlayClick={false}
    size="small"
    onRequestClose={onRequestClose}
  >
    <Shimmer width="40%" height={32} ml={24} mt={24} mb={16} />
    <ModalCloseButton onClick={onRequestClose} />

    <ModalBody>
      <Grid>
        {times(2).map(key => (
          <Box key={key}>
            <Shimmer width="100%" height={64} />
          </Box>
        ))}
      </Grid>
    </ModalBody>
  </Modal>
);
